import { defineComponent as _defineComponent } from 'vue'
import { ref, computed } from 'vue';
import BDListBlock from 'bd-common/src/components/list/BDListBlock.vue';
import ProductsListing from '@/app/components/products/ProductsListing.vue';
import ProductsDetailsModal from '@/app/components/products/ProductsDetailsModal.vue';
import { BhMenuItem } from 'bd-common/src/components/common/menus/BhBaseMenu.vue';
import WarningSplash from 'bd-common/src/components/common/WarningSplash.vue';
import { VButton } from 'ah-common-lib/src/common/components';
import ViewTabsMenu from 'bd-common/src/components/common/menus/ViewTabsMenu.vue';
import SearchFilter from 'bd-common/src/components/form/SearchFilter.vue';
import { useQueryParamRef } from 'ah-common-lib/src/helpers/useQueryParam';
import { productsListingTableFields } from '@/app/components/products/productsListingTableFields';
import { PaginatedParams, Product } from 'ah-api-gateways';
import MaterialIcon from 'bd-common/src/components/common/MaterialIcon.vue';
import { config } from '@/config';

type ViewMenuItem = (typeof viewMenuKeys)[number];


export default /*#__PURE__*/_defineComponent({
  __name: 'ProductsView',
  setup(__props) {

const productsListBlock = ref<InstanceType<typeof BDListBlock>>();
const productsDetailsModal = ref<InstanceType<typeof ProductsDetailsModal>>();

const selectedProduct = ref<Product>();

const viewMenuKeys = ['currencies'] as const;

const viewMenuItems: BhMenuItem[] = [{ label: 'Currencies', value: 'currencies', icon: 'format_list_bulleted' }];

const showProductsBankHedge = computed(() => !!config.showProductsBankHedge);

const selectedMenu = useQueryParamRef<ViewMenuItem>('tab', 'currencies', {
  deserialize(param) {
    if (!viewMenuKeys.includes(param as ViewMenuItem)) {
      return 'currencies';
    }
    return param as ViewMenuItem;
  },
});

function getCustomHeading(hasCustomFilters: boolean | undefined, filter: any) {
  if (hasCustomFilters) {
    return filter.query
      ? `We couldn’t find search results for "${filter.query}"`
      : 'We couldn’t find results matching your filter(s)';
  } else {
    return 'There are no currency pairs to display';
  }
}

function getCustomSubHeading(hasCustomFilters: boolean | undefined, filter: any) {
  if (hasCustomFilters) {
    return filter.query ? 'Please clear or try another search' : 'Please clear or try other filters';
  } else {
    return '';
  }
}

// defaultSortAndPageParams is purposefully not reactive, so as to not trigger any change detection
const defaultSortAndPageParams: Partial<PaginatedParams> = {
  sort: 'sellCurrency',
  sortDirection: 'DESC',
};

const listConfig = computed(() => {
  return {
    tableFields: productsListingTableFields,
  };
});

function onViewHistory(product: any) {
  selectedProduct.value = product;
  productsDetailsModal.value?.modal?.show();
}

return { __sfc: true,productsListBlock, productsDetailsModal, selectedProduct, viewMenuKeys, viewMenuItems, showProductsBankHedge, selectedMenu, getCustomHeading, getCustomSubHeading, defaultSortAndPageParams, listConfig, onViewHistory, BDListBlock, ProductsListing, ProductsDetailsModal, WarningSplash, VButton, ViewTabsMenu, SearchFilter, MaterialIcon }
}

})